import type { CSSInterpolation } from '@emotion/css';
import { css } from '@emotion/css';
import React from 'react';

export type BrandProps = {
  mode?: 'light' | 'dark';
  sx?: CSSInterpolation;
};

export function Brand({ sx, mode = 'light' }: BrandProps) {
  const styles = css(sx);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 554 79"
      xmlSpace="preserve"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={styles}
    >
      <path
        style={{ fill: mode === 'dark' ? '#fff' : '#000' }}
        d="M10 11.12h26c6.4 0 11.44 1.76 14.64 4.96 2.56 2.56 3.84 5.68 3.84 9.52v.16c0 6.32-3.36 9.84-7.36 12.08C53.6 40.32 57.6 44.08 57.6 51.6v.16c0 10.24-8.32 15.36-20.96 15.36H10v-56zm32.24 16.56c0-3.68-2.88-5.76-8.08-5.76H22v11.84h11.36c5.44 0 8.88-1.76 8.88-5.92v-.16zm-6 16.32H22v12.32h14.64c5.44 0 8.72-1.92 8.72-6.08v-.16c0-3.76-2.8-6.08-9.12-6.08zM65.51 11.12h12.32v56H65.51v-56zM85.8 39.28v-.16c0-15.92 12.56-28.96 29.84-28.96s29.68 12.88 29.68 28.8v.16c0 15.92-12.56 28.96-29.84 28.96S85.8 55.2 85.8 39.28zm46.64 0v-.16c0-9.6-7.04-17.6-16.96-17.6-9.92 0-16.8 7.84-16.8 17.44v.16c0 9.6 7.04 17.6 16.96 17.6 9.92 0 16.8-7.84 16.8-17.44zM152.19 39.28v-.16c0-15.92 12-28.96 29.2-28.96 10.56 0 16.88 3.52 22.08 8.64l-7.84 9.04c-4.32-3.92-8.72-6.32-14.32-6.32-9.44 0-16.24 7.84-16.24 17.44v.16c0 9.6 6.64 17.6 16.24 17.6 6.4 0 10.32-2.56 14.72-6.56l7.84 7.92c-5.76 6.16-12.16 10-22.96 10-16.47 0-28.72-12.72-28.72-28.8zM211.82 11.12h42.24v10.96h-30v11.36h26.4V44.4h-26.4v11.76h30.4v10.96h-42.64v-56zM265.12 11.12h11.36l26.24 34.48V11.12h12.16v56H304.4l-27.12-35.6v35.6h-12.16v-56zM339.19 22.48h-17.04V11.12h46.4v11.36h-17.04v44.64h-12.32V22.48zM375.42 43.12v-32h12.32V42.8c0 9.12 4.56 13.84 12.08 13.84 7.52 0 12.08-4.56 12.08-13.44V11.12h12.32v31.6c0 16.96-9.52 25.28-24.56 25.28s-24.24-8.4-24.24-24.88zM436.38 11.12h25.6c7.12 0 12.64 2 16.32 5.68 3.12 3.12 4.8 7.52 4.8 12.8v.16c0 9.04-4.88 14.72-12 17.36l13.68 20h-14.4l-12-17.92h-9.68v17.92h-12.32v-56zm24.8 27.2c6 0 9.44-3.2 9.44-7.92v-.16c0-5.28-3.68-8-9.68-8H448.7v16.08h12.48zM506.26 45.04l-21.52-33.92h14.4L512.5 33.6l13.6-22.48h14L518.58 44.8v22.32h-12.32V45.04z"
      />
      <g>
        <path
          style={{ fill: '#EE2424' }}
          d="M22 44.04V44H10v12.32h12v-.04l12-6.12z"
        />
      </g>
    </svg>
  );
}
